import Toast from 'react-bootstrap/Toast';
import {
  ToastStyled,
  ToastHeaderStyled
} from './Toast.styled'


const ToastWrapper = ({ show, setShow, title, description }) => {
  return (
    <ToastStyled onClose={() => setShow(false)} show={show} delay={3000} autohide>
      <ToastHeaderStyled closeVariant='white'>
        <strong className="me-auto">{title}</strong>
      </ToastHeaderStyled>
      <Toast.Body>{description}</Toast.Body>
    </ToastStyled>
  )
}

export default ToastWrapper;